import styled from 'styled-components'
import * as All from '../BaseStyles'

import logoIcon from '../../Icons/Logos/qf-logo.png'

export const LogInDiv = styled(All.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const LogInComponentsDiv = styled(All.Div)`
    box-shadow:
        0 0px 3.8px rgba(0, 0, 0, 0.022),
        0 0px 8.3px rgba(0, 0, 0, 0.031),
        0 0px 14.9px rgba(0, 0, 0, 0.039),
        0 0px 30.5px rgba(0, 0, 0, 0.048),
        0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: white;
    padding: 0.75%;
`

export const QuickFillerButtonDiv = styled(All.Div)`
    margin-bottom: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const LogInFieldsDiv = styled(All.Div)`
    padding: 6rem 2rem;
    width: 100%;
`

export const LogInFormDiv = styled(All.Div)`
    margin: 0rem 2rem;
`

export const SignInButtonDiv = styled(All.Div)`
    margin-top: 3rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ForgotPasswordDiv = styled(All.Div)`
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const QuestionDiv = styled(All.Div)`
    margin-top: 2rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const SignUpButtonDiv = styled(All.Div)`
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const TitleIconButton = styled(All.IconButton)`
    margin-right: 0.5rem;
    padding: 0;
    width: 3rem;
    height: 3rem;
    background-image: url(${logoIcon});
`

export const QuickFillerButton = styled.button`
    margin: 0;
    padding: 0;
    color: black;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    line-height: 3rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    &:hover {
        color: #4267B2;
    }
`

export const LogInTitle = styled.h2`  
    margin: 0;
    padding: 0rem;
    padding-bottom: 7rem;
    font-size: 2.5rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`

export const LogInRowDiv = styled(All.Div)`
    width: 100%;
    overflow: hidden;
`

export const FullLogInDiv = styled(All.Div)`
    width: 100%;
    display: inline-block;
`

export const LogInHeader = styled.p`
    margin: 0;
    padding: 0;
    margin-bottom: 0.4rem;
    font-size: 1.2rem;
    font-weight: 450;
`

export const CredentialInputField = styled(All.InputField)`
    font-size: 1.65rem;
    height: 3rem;
    width: 100%;
    padding: 0rem 0.2rem; 
`

export const EmailInputField = styled(CredentialInputField)`
    margin-bottom: 1rem;
`

export const PasswordInputField = styled(CredentialInputField)`
    margin-bottom: 0.6rem;
`

export const RememberMeLabel = styled.label`
    margin: 0;
    display: inline-block;
    white-space: nowrap;
    font-size: 1.6rem;
    font-weight: normal;
    margin-bottom: 3rem;
`

export const RememberMeSpan = styled.span`
    vertical-align: middle;
`

export const RememberMeBox = styled.input`
    margin: 0;
    margin-right: 0.4rem;
    vertical-align: middle;
    width: 1.8rem;
    height: 1.8rem;
`

export const ActionButton = styled.button`
    margin: 0;
    padding: 0.6rem 0rem;
    width: 40%;
    font-size: 1.8rem;
    color: black;
    outline-styles: none;
    border-radius: 0.7rem;
    border-style: solid;
    border-width: thin;
    cursor: pointer;
`

export const SignUpButton = styled(ActionButton)`
    background-color: transparent;
    border-color: #4267B2;
    &:hover{
        background-color: #4267B2;
        color: white;
    }
`

export const SignInButton = styled(ActionButton)`
    background-color: transparent;
    border-color: #383838;
    &:hover{
        background-color: #383838;
        color: white;
    }
`

export const QuestionPhrase = styled.h5`
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-weight: normal;
`

export const ForgotPasswordButton = styled.button`
    margin: 0;
    padding: 0; 
    background: none!important;
    border: none;
    padding: 0!important;
    color: #069;
    cursor: pointer;
    &:hover{
        color: #00ccff;
    }
`
